import { StateFastForward } from '../core';
import { makeTimelineEntry } from '../timelineEntries';
import { captureStateSnapshot } from '../snapshot';
import { waitWhile, drainShorterThan } from '../waits';

export const handleSetProduction = (state, timeline, recorder, action, index) => {
  const { payload } = action;
  const { planetId, settings } = payload;

  if (settings.awaitBuilding) {
    state = waitWhile(state, timeline, recorder, planetId, (s) => s.planets[planetId].buildAction !== undefined, {
      captureSnapshots: true,
    });
  }
  if (settings.awaitResearch) {
    state = waitWhile(state, timeline, recorder, planetId, (s) => s.researchAction !== undefined, {
      captureSnapshots: true,
    });
  }
  if (settings.awaitHangar) {
    state = waitWhile(state, timeline, recorder, planetId, (s) => s.planets[planetId].shipActions.length !== 0, {
      captureSnapshots: true,
    });
  }

  const beforeProdState = captureStateSnapshot(state, planetId);
  state.planets[planetId].productionFactors = {
    ...state.planets[planetId].productionFactors,
    metalMine: settings.metalMine,
    crystalMine: settings.crystalMine,
    deuteriumSynthesizer: settings.deuteriumSynthesizer,
  };
  const afterProdState = captureStateSnapshot(state, planetId);

  recorder.record(
    state,
    planetId,
    `Changed production settings (M:${Math.round(settings.metalMine * 100)}%, C:${Math.round(settings.crystalMine * 100)}%, D:${Math.round(settings.deuteriumSynthesizer * 100)}%)`
  );

  timeline.push(makeTimelineEntry('start', state, { ...action, duration: settings.extra_wait, index }, beforeProdState, afterProdState));

  const drained = drainShorterThan(
    state,
    timeline,
    recorder,
    planetId,
    settings.extra_wait,
    (s, threshold, completedAction) => threshold - completedAction.duration,
    { captureSnapshots: true }
  );
  state = drained.state;
  settings.extra_wait = drained.threshold;

  if (settings.extra_wait > 0) {
    state = StateFastForward(state, planetId, settings.extra_wait, recorder);
  }

  return state;
};
